export default __webpack_public_path__ + "79ba637382d96d1e82e752930effb9ff.svg";